import Http from './http'

export default {
  index(filter){
    return Http.get(`/default_import_files`, {params: { ...filter }});
  },

  show(id){
    return Http.get(`/default_import_files/${id}`);
  },
  create(default_import_file){
    return Http.post(`/default_import_files`, { default_import_file: {...default_import_file} } )
  },
  createFormData(default_import_file){
    const formData = new FormData()
    // formData.append(`${data}[id]`, parseInt(id));
    formData.append(`default_import_file[name]`,         default_import_file.name);
    formData.append(`default_import_file[status]`,         default_import_file.status);
    formData.append(`default_import_file[ref_model_name]`, default_import_file.ref_model_name);
    formData.append(`default_import_file[format]`,         default_import_file.format || 'xlsx');
    formData.append(`default_import_file[kind]`,    default_import_file.kind);
    formData.append(`default_import_file[file]`,  default_import_file.file);

    default_import_file = formData
    
    return Http.post(`/default_import_files`, default_import_file, {headers: {
      'Content-Type': 'multipart/form-data'
    } } )
  },
  updateFormData(default_import_file){
    let {id} = default_import_file
    const formData = new FormData()
    // formData.append(`${data}[id]`, parseInt(id));
    formData.append(`default_import_file[name]`,         default_import_file.name);
    formData.append(`default_import_file[status]`,         default_import_file.status);
    formData.append(`default_import_file[ref_model_name]`, default_import_file.ref_model_name);
    formData.append(`default_import_file[format]`,         default_import_file.format || 'xlsx');
    formData.append(`default_import_file[kind]`,    default_import_file.kind);
    if (default_import_file.file){
      formData.append(`default_import_file[file]`,  default_import_file.file);
    }

    default_import_file = formData
    
    return Http.put(`/default_import_files/${id}`, default_import_file , {headers: {
      'Content-Type': 'multipart/form-data'
    } })
  },
  download(id){
    return Http.get(`/default_import_files/${id}/download`);
  },
}


